import React, { useEffect, useState } from "react";

import Header from "./Header";
import "./Accomodation.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Navigate, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
// import ConcellationRefund from "./ConcellationRefund";
import "./BillingDetails.css";
import host from "../config";
const RoomBookingPreview = () => {
  // let host = "https://api.vmrdarental.com";
  // let host = "https://api.vmrdarental.com";
  const navigate = useNavigate();

  const [panValidation, setPanValidation] = React.useState(true);
  const [proofValidation, setProofValidation] = React.useState(true);
  const [proofType, setProofType] = React.useState("pan");
  const [aadhaar, setAadhaar] = useState("");
  const [selectedPurpose, setSelectedPurpose] = useState("");
  const [filteredBookingDetails, setFilteredBookingDetails] = useState([]);

  const handleAadhaarChange = (e) => {
    setAadhaar(e.target.value);
    billingRequest.aadhaar = e.target.value;
  };

  const handleProofTypeChange = (e) => {
    setProofType(e.target.value);
    setProofValidation(true); // Reset validation when changing proof type
    console.log("Proof Type:", e.target.value);
    // Add a console.log to check proofType and the Aadhaar input
    console.log("Aadhaar Value:", aadhaar);
  };

  const validateProof = (proofValue, proofType) => {
    if (proofType === "aadhaar") {
      const aadhaarRegex = /^\d{12}$/;
      return aadhaarRegex.test(proofValue);
    } else if (proofType === "pan") {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      return panRegex.test(proofValue);
    }
    return false;
  };

  const handleProofInput = (e) => {
    const proofValue = e.target.value.toUpperCase();
    console.log("Aadhaar Value:", proofValue);
    setProofValidation(validateProof(proofValue, proofType));
  };

  const validatePanCard = (panCard) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    return panRegex.test(panCard);
  };

  const handlePanInput = (e) => {
    const panValue = e.target.value.toUpperCase();
    setPanValidation(validatePanCard(panValue));
  };

  localStorage.removeItem("bookingDetailsDataFinal");
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    localStorage.removeItem("bookingDetailsData");
  }
  // if (localStorage.getItem("bookingDetailsData") == undefined) {
  //   navigate("/Accommodation", "_self");
  // }
  let bookingDetailsData = localStorage.getItem("selectedRoomData");
  if (bookingDetailsData) {
    bookingDetailsData = JSON.parse(bookingDetailsData);
  } else {
    navigate("/Accommodation", "_self");
  }
  console.log("bookungD", bookingDetailsData);
  // console.log(bookingDetailsDataFinal,"datafinal")
  const [grandAmountFinal, setGrandAmountFinal] = React.useState(0);
  const [bookingDetailsDataFinal, setBookingDetailsDataFinal] = React.useState(
    []
  );
  const [paymentEncyData, setPaymentEncyData] = React.useState("");

  let sumGrandTotalAmount = 0;
  let bookingDetailsDataFinalTmp = [];
  let seqNo = 1;
  let srNo = 0;
  let grandTotal = 0;
  let billingRequest = JSON.parse("{}");
  let captchSumValue = 0;

  bookingDetailsData.selectedRooms.map((e, i) => {
    for (let i = 0; i < bookingDetailsData.daysStay; i++) {
      let roomObj = JSON.parse(JSON.stringify(e));
      let tmpDate = new Date(bookingDetailsData.fromDate);
      tmpDate.setDate(tmpDate.getDate() + i);
      roomObj.bookingDate = tmpDate;
      roomObj.rmSeqId = seqNo;
      roomObj.selectedPersons = roomObj.persons;
      roomObj.grandTotalVal = roomObj.amount;
      roomObj.finalGrandTotalVal = roomObj.amount;
      roomObj.purpose = roomObj.purpose;
      bookingDetailsDataFinalTmp.push(roomObj);

      sumGrandTotalAmount = sumGrandTotalAmount + e.amount;
      seqNo++;
    }
  });
  console.log(bookingDetailsDataFinalTmp, "bookingDetailsDataFinalTmp");

  // const grandTotal = filteredBookingDetails.reduce(
  //   (total, item) => total + item.amount,
  //   0
  // );

  useEffect(() => {
    setGrandAmountFinal(sumGrandTotalAmount);
    setBookingDetailsDataFinal(bookingDetailsDataFinalTmp);
  }, []);

  if (
    localStorage.getItem("bookingDetailsDataFinal") !== undefined &&
    localStorage.getItem("bookingDetailsDataFinal") !== null
  ) {
    bookingDetailsDataFinal = JSON.parse(
      localStorage.getItem("bookingDetailsDataFinal")
    );
    setBookingDetailsDataFinal(bookingDetailsDataFinal);
  }
  console.log("final booking", bookingDetailsDataFinal);
  const handleMobileNumberInput = (e) => {
    const maxLength = 10;
    let inputValue = e.target.value;

    // Trim input to the maximum length
    if (inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
      e.target.value = inputValue;
    }
  };

  const generateRandomNumber = () => {
    const min = 1;
    const max = 9;
    let captchVal = Math.floor(Math.random() * (max - min + 1)) + min;
    captchSumValue = captchSumValue + captchVal;
    return captchVal;
  };

  const proceedToPayValidation = () => {
    if (
      document.getElementById("customer_name").value === undefined ||
      document.getElementById("customer_name").value === ""
    ) {
      alert("Please provide the valid customer name");
      return false;
    }
    if (
      document.getElementById("customer_address").value === undefined ||
      document.getElementById("customer_address").value === ""
    ) {
      alert("Please provide the valid customer address");
      return false;
    }

    const mobileNumber = document.getElementById("customer_contactno").value;
    if (
      mobileNumber === undefined ||
      mobileNumber === "" ||
      mobileNumber.length !== 10 ||
      isNaN(mobileNumber)
    ) {
      alert("Please provide a valid 10-digit mobile number");
      return false;
    }

    // const purpose = document.getElementById("purpose").value;
    // if (purpose === "") {
    //   alert("Please select a purpose");
    //   return false;
    // }

    const fileInput = document.getElementById("uploadedFile");
    if (!fileInput.files || fileInput.files.length === 0) {
      alert("Please upload a file");
      return false;
    }

    if (
      captchSumValue !== parseInt(document.getElementById("captch_value").value)
    ) {
      alert(
        "Given number is invalid, please provide the valid sum value of the given numbers"
      );
      return false;
    }

    if (!document.getElementById("termsandconditions").checked) {
      alert("Please click the checkbox to accept the terms and conditions.");
      return false;
    }

    return true;
  };

  const handleFileUpload = async (event) => {
    const fileInput = event.target.files[0];
    if (fileInput) {
      const formData = new FormData();
      formData.append("image", fileInput); // Ensure 'image' matches the field name used in the backend

      try {
        const response = await fetch(`${host}/upload`, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        if (response.ok) {
          console.log("File uploaded successfully:", result.location); // Use 'result.location' here
          billingRequest.uploadedFile = result.location; // Store the file URL in the billing request
        } else {
          alert("File upload failed!");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("File upload failed!");
      }
    }
  };

  const proceedToPay = () => {
    let validationResult = proceedToPayValidation();
    if (validationResult === false) {
      return;
    }

    billingRequest.locationId = bookingDetailsData.locationId;
    billingRequest.name = document.getElementById("customer_name").value;
    billingRequest.address = document.getElementById("customer_address").value;
    billingRequest.contactno =
      document.getElementById("customer_contactno").value;
    billingRequest.email = document.getElementById("customer_email").value;

    billingRequest.pan =
      proofType === "pan" ? document.getElementById("customer_pan").value : "";
    billingRequest.aadhaar =
      proofType === "aadhaar"
        ? document.getElementById("customer_aadhaar").value
        : "";
    billingRequest.termsAndConditions =
      document.getElementById("termsandconditions").checked;

    billingRequest.uploadedFile = billingRequest.uploadedFile;
    // billingRequest.purpose = document.getElementById("purpose").value;
    billingRequest.rooms = bookingDetailsData;
    billingRequest.roomData = bookingDetailsDataFinal;

    // Add calculated amount
    billingRequest.totalAmount = grandAmountFinal;

    // Store billingRequest in local storage
    localStorage.setItem("billingRequest", JSON.stringify(billingRequest));
    console.log("Billing Request:", billingRequest);

    // Make API call
    fetch(host + "/proceed-room-booking", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(billingRequest),
    })
      .then((data) => {
        if (data.status == 403) {
          alert(
            "We regret to inform you that we are currently unable to process your request. Kindly try again later"
          );
          navigate("/");
          return;
        }
        if (data.status === 401) {
          alert("Session expired. Please log in and try again.");
          navigate("/Login");
          return;
        }
        data.json().then((res) => {
          console.log("API Response:", res);
          if (res.amount !== grandAmountFinal) {
            console.error("Amount mismatch:", res.amount, grandAmountFinal);
          }

          // document.getElementById("encRequest").value = res.data;
          document.getElementById("order_id").value = res.data;
          document.getElementById("amount_id").value = res.amount;
          document.getElementById("key_id").value = res.apiKey;

          document.redirect.submit();
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <div>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-lg-2"></div>
          <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10  content_back">
            <div className="center_title" style={{ fontSize: "24px" }}>
              Venue Booking Details
            </div>

            <div className="row">
              <div className="col-md-3 center"></div>
              <div
                className="col-md-6 center billing_details_form"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <form>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control billing_details_form-control"
                      id="customer_name"
                      aria-describedby="Name"
                      placeholder="Name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Address</label>
                    <textarea
                      name="address"
                      style={{ minHeight: 100 }}
                      className="form-control billing_details_form-control"
                      id="customer_address"
                      aria-describedby="Address"
                      placeholder="Address"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Contact No.</label>
                    <input
                      type="text"
                      name="mobileNumber"
                      className="form-control billing_details_form-control"
                      id="customer_contactno"
                      aria-describedby="Contact No"
                      placeholder="Contact No"
                      onInput={(e) => handleMobileNumberInput(e)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">E-mail</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control billing_details_form-control"
                      id="customer_email"
                      aria-describedby="E-Mail"
                      placeholder="E-Mail"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="proof_type">Proof Type</label>
                    <select
                      className="form-control billing_details_form-control"
                      id="proof_type"
                      value={proofType}
                      onChange={handleProofTypeChange}
                      style={{ paddingTop: "5px" }}
                    >
                      <option value="pan">PAN</option>
                      <option value="aadhaar">Aadhaar</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor={`customer_${proofType}`}>
                      Proof ({proofType.toUpperCase()})
                    </label>
                    <input
                      type="text"
                      name={proofType}
                      className={`form-control billing_details_form-control ${
                        !proofValidation ? "is-invalid" : ""
                      }`}
                      id={`customer_${proofType}`}
                      aria-describedby={`Proof (${proofType.toUpperCase()})`}
                      placeholder={`Proof (${proofType.toUpperCase()})`}
                      onBlur={handleProofInput}
                    />
                    {!proofValidation && (
                      <div className="invalid-feedback">
                        Invalid {proofType.toUpperCase()} number
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="captch_value">Verify Human</label>
                    <div>
                      <div style={{ float: "left" }}>
                        {generateRandomNumber()} + {generateRandomNumber()} =
                      </div>
                      <div style={{ float: "left" }}>
                        <input
                          type="text"
                          name="captcha"
                          className="form-control form-control-captcha"
                          id="captch_value"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                  <br />

                  <div className="form-group">
                    <label htmlFor="file_upload">Upload File</label>
                    <input
                      type="file"
                      id="uploadedFile"
                      name="uploadedFile"
                      className="form-control"
                      onChange={handleFileUpload}
                    />
                  </div>

                  <div className="form-group" style={{ float: "left" }}>
                    <input
                      className="largerCheckbox"
                      type="checkbox"
                      id="termsandconditions"
                    />
                    &nbsp; I agree to the above specified{" "}
                    <a href="/terms-conditions">Terms and Conditions</a>
                  </div>
                </form>
              </div>
              <div className="col-md-3 center"></div>
            </div>

            <table className="table table-striped">
              <th>S.No</th>
              <th>Venue Name</th>
              <th>Date</th>
              <th>Amount</th>

              <th>Subtotal</th>

              {bookingDetailsDataFinal.map((e, i) => {
                grandTotal = grandTotal + e.amount;
                srNo++;
                return (
                  <tr>
                    <td>{srNo}</td>
                    <td>{e.location_id} </td>
                    <td>{moment(e.bookingDate).format("yyyy-MM-DD")}</td>
                    <td>{e.amount}</td>

                    <td id={"daysStay_subtotal_" + e.rmSeqId}>
                      {" "}
                      {e.grandTotalVal}{" "}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td colSpan="3"></td>
                <td>Grand Total</td>
                <td>{grandAmountFinal}</td>
              </tr>
            </table>

            <button
              className="back_button float_left"
              onClick={() => navigate("/Accommodation", "_self")}
            >
              Back
            </button>
            <button
              className="booking_button float_right"
              onClick={() => proceedToPay()}
            >
              Proceed to Pay
            </button>

            <div className="container" style={{ paddingTop: "10%" }}>
              {/* <ConcellationRefund /> */}
            </div>
          </div>
        </div>

        <form
          method="POST"
          name="redirect"
          action="https://api.razorpay.com/v1/checkout/embedded"
        >
          <input type="hidden" name="key_id" id="key_id" value="" />
          <input type="hidden" id="order_id" name="order_id" value="" />
          <input type="hidden" id="amount_id" name="amount" value="" />
          {/* <input
            type="hidden"
            name="callback_url"
            value="https://api.vmrdarental.com/razorpay-response"
          /> */}
          <input
            type="hidden"
            name="callback_url"
            value={`${host}/razorpay-response`}
          />
        </form>
      </div>
    </div>
  );
};
export default RoomBookingPreview;
